import React from 'react';
export function BooksSection() {
  const books = [{
    id: '01',
    emoji: '🌍',
    title: 'Descubro el Mundo',
    desc: 'Actividades sobre sí mismo, su familia y su cuerpo para desarrollar el autoconocimiento.',
    color: 'bg-blue-100 border-blue-300',
    textColor: 'text-blue-800',
    numberBg: 'bg-blue-500',
    shadowColor: 'shadow-blue-200'
  }, {
    id: '02',
    emoji: '🔢',
    title: 'Aprendo los Fundamentos',
    desc: 'Los colores, figuras geométricas y números de forma lúdica y visual.',
    color: 'bg-green-100 border-green-300',
    textColor: 'text-green-800',
    numberBg: 'bg-green-500',
    shadowColor: 'shadow-green-200'
  }, {
    id: '03',
    emoji: '🔤',
    title: 'Las Vocales',
    desc: 'Introducción a las vocales, acciones y objetos cotidianos del hogar.',
    color: 'bg-amber-50 border-amber-200',
    textColor: 'text-amber-700',
    numberBg: 'bg-amber-400',
    shadowColor: 'shadow-amber-100'
  }, {
    id: '04',
    emoji: '🧩',
    title: 'Exploro y Clasifico',
    desc: 'Juegos de clasificación: animales, alimentos y medios de transporte.',
    color: 'bg-purple-100 border-purple-300',
    textColor: 'text-purple-800',
    numberBg: 'bg-purple-500',
    shadowColor: 'shadow-purple-200'
  }, {
    id: '05',
    emoji: '💖',
    title: 'Siento y Aprendo',
    desc: 'Reconocimiento de emociones y fomento de buenas conductas.',
    color: 'bg-pink-100 border-pink-300',
    textColor: 'text-pink-800',
    numberBg: 'bg-pink-500',
    shadowColor: 'shadow-pink-200'
  }, {
    id: '06',
    emoji: '🌿',
    title: 'Descubro el Mundo Natural',
    desc: 'Exploración de texturas y elementos de la naturaleza que nos rodea.',
    color: 'bg-orange-100 border-orange-300',
    textColor: 'text-orange-800',
    numberBg: 'bg-orange-500',
    shadowColor: 'shadow-orange-200'
  }];
  return <section className="py-8 md:py-10 px-4 bg-[#f7faff]" data-id="element-63">
      <div className="max-w-5xl mx-auto" data-id="element-64">
        <div className="text-center mb-5" data-id="element-65">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3" data-id="element-66">
            ¿Qué incluye el kit?
          </h2>
          <div className="inline-flex items-center justify-center bg-blue-600 text-white px-4 py-1.5 rounded-full font-black text-sm md:text-base uppercase tracking-wider shadow-lg shadow-blue-200" data-id="element-67">
            📚 6 LIBROS COMPLETOS + 3 BONOS EXCLUSIVOS
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-4 max-w-2xl mx-auto" data-id="element-68">
          {books.map(book => <div key={book.id} className={`relative bg-white border-2 rounded-xl p-3 md:p-4 shadow-md aspect-square flex flex-col justify-center items-center text-center ${book.color} ${book.shadowColor}`} data-id="element-69">
              {/* Number Badge */}
              <div className={`absolute -top-2.5 -left-2.5 w-8 h-8 rounded-full ${book.numberBg} text-white flex items-center justify-center text-xs font-black shadow-md border-2 border-white z-10`} data-id="element-70">
                {book.id}
              </div>

              <span className="text-3xl mb-2" data-id="element-71">{book.emoji}</span>
              <h3 className={`text-sm md:text-base font-black ${book.textColor} leading-tight mb-2`} data-id="element-72">
                {book.title}
              </h3>
              <p className="text-gray-600 font-medium text-sm leading-snug px-1" data-id="element-73">
                {book.desc}
              </p>
            </div>)}
        </div>

        <div className="mt-6 text-center bg-white border-2 border-gray-200 rounded-xl p-4 max-w-2xl mx-auto shadow-md relative overflow-hidden" data-id="element-74">
          <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-blue-400 via-green-400 to-yellow-400" data-id="element-75"></div>
          <p className="text-base md:text-lg font-bold text-gray-800 flex items-center justify-center gap-2" data-id="element-76">
            <span className="text-2xl" data-id="element-77">🖨️</span>
            Todo el material está diseñado en alta calidad, listo para descargar
            e imprimir desde tu casa.
          </p>
        </div>
      </div>
    </section>;
}